export function isValidBrazilianPhone(phone?: string): boolean {
  if (!phone) return false

  const digits = phone.replace(/\D/g, '')

  const allDigitsSame = (str: string) =>
    str.split('').every((digit) => digit === str[0])

  if (digits.length === 11) {
    const ddd = parseInt(digits.substring(0, 2))
    const firstDigit = digits[2]
    if (allDigitsSame(digits)) return false
    return ddd >= 11 && ddd <= 99 && firstDigit === '9'
  }

  if (digits.length === 13 && digits.startsWith('55')) {
    const ddd = parseInt(digits.substring(2, 4))
    const firstDigit = digits[4]
    const phonePart = digits.substring(2)
    if (allDigitsSame(phonePart)) return false
    return ddd >= 11 && ddd <= 99 && firstDigit === '9'
  }
  return false
}
